import styled from '@emotion/styled';

import { hoverable, Typography } from '@/design-system';

import { ChainIcon, ChainId } from './chain-icon';
import { CHAINS, RECEIVE_NETWORKS } from './chains';

export interface ReceiveNetworkSelectionProps {
  symbol: string;
  onChainChange?: (_chainId: ChainId) => void;
}

const NetworkSelection = styled('div')(({ theme: t }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: t.spacing[16],
}));
const NetworkList = styled('div')(({ theme: t }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: t.spacing[16],
}));
const NetworkButton = styled('button')(({ theme: t }) => ({
  ...hoverable(t, 'surfaceRaised'),
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  minHeight: 56,
  gap: t.spacing[8],
  padding: `${t.spacing[12]}px`,
  border: 0,
  borderRadius: t.radius[16],
  color: t.colors.text.primary,
  backgroundColor: t.colors.background.raised,
  cursor: 'pointer',
  textAlign: 'left',
  touchAction: 'manipulation',
  WebkitTapHighlightColor: 'transparent',
  '&:focus-visible': { boxShadow: `0 0 0 2px ${t.colors.white[20]}` },
}));

export const ReceiveNetworkSelection = ({
  symbol,
  onChainChange,
}: ReceiveNetworkSelectionProps) => (
  <NetworkSelection>
    <Typography as="h2" variant="h5">
      Select the network you are sending from:
    </Typography>
    <NetworkList>
      {RECEIVE_NETWORKS.map((chainId) => (
        <NetworkButton
          key={chainId}
          type="button"
          aria-label={`Receive ${symbol} on ${CHAINS[chainId].label}`}
          onClick={() => onChainChange?.(chainId)}
        >
          <ChainIcon chainId={chainId} size={28} />
          <Typography as="span" variant="body1" fontWeight={500}>
            {CHAINS[chainId].label}
          </Typography>
        </NetworkButton>
      ))}
    </NetworkList>
  </NetworkSelection>
);
